// Transforme le résultat de diffContent (par collection) en lignes lisibles
// pour l'UI : une ligne par collection réellement touchée, avec les compteurs
// ajouté/supprimé/modifié. Les collections inchangées sont omises.

const COLLECTION_LABELS = {
  boxes: 'Éléments',
  containers: 'Blocs',
  columns: 'Colonnes',
  variableGroups: 'Groupes de variables',
  masks: 'En-têtes / pieds de page',
  variables: 'Variables',
  triggers: 'Déclencheurs',
};

const WHOLE_LABELS = {
  configuration: 'Configuration',
  variableOrderArray: 'Ordre des variables',
};

export const summarizeDiff = (diff) => {
  if (!diff || diff.isEmpty) return [];

  const lines = [];

  Object.entries(COLLECTION_LABELS).forEach(([key, label]) => {
    const group = diff[key];
    if (!group) return;
    const added = group.added.length;
    const removed = group.removed.length;
    const modified = group.modified.length;
    if (added || removed || modified) {
      lines.push({ key, label, added, removed, modified });
    }
  });

  Object.entries(WHOLE_LABELS).forEach(([key, label]) => {
    if (diff[key]?.changed) lines.push({ key, label, changed: true });
  });

  return lines;
};
